import React, { ReactNode } from "react";
import BeverageHistoryPage from "app/common/BeverageHistoryPage";
import ReportingService from "../reporting/reporting.service";
import {IPurchasedItemInfo} from "app/app.types";

/** Service to get beverage history for the specified customer */
class BeverageHistoryService {

  /** Provides <BeverageHistoryPage /> to pass as a child to <AlertDialog /> from customerDetails page. */
  public getBeverageHistoryPageComponent(beverageList: IPurchasedItemInfo[], currency: string): ReactNode {
    return <BeverageHistoryPage beverageList={beverageList} currency={currency} />
  }

  /** Provides the list of beverages consumed by the customer till date */
  public async getCustomerBeverageInfo(venueId: number, customerId: string): Promise<IPurchasedItemInfo[]> {

    let beverages = [] as IPurchasedItemInfo[];

    const itemList = await ReportingService.getPurchasedItemsByCustomerId(venueId, customerId);
    if (itemList?.length) {

      const beverageNameList: IPurchasedItemInfo[] = itemList.filter(item => item.salesCategoryName.toLowerCase() === "beverage");

      // Remove duplicate items from the beverage array
      beverages = Array.from(new Set(beverageNameList));
    }

    return beverages;
  }
}

// creates a singleton instance to export
const instance = new BeverageHistoryService();
export default instance as BeverageHistoryService;
